<template>
  <div v-if="menusList[0].icon" class="menu indexC" :class="desktopStatus == false ? '' : 'desktopBody'" :style="isCollapse ? 'width: 65px;' : 'width: 125px;'">
    <div v-if="desktopStatus == false" :class="isCollapse ? 'indexLogo2' : 'indexLogo'">
      <img :src="shopImg ? shopImg : 'static/images/yangzi.png'" />
    </div>
    <div v-else class="desktopMenu"></div>
    <el-menu :default-active="menuIndex" :class="desktopStatus == false ? 'el-menu-vertical-demo' : 'el-menu-vertical-demo desktopMenuHeight'" :text-color="desktopStatus == true ? '#333' : '#fff'" :active-text-color="desktopStatus == true ? '#09d8fd' : '#fff'" :collapse="isCollapse" @select="handleOpen">
      <el-menu-item v-if="menusList.find(data => data.iDenTi === 'beauty-1-qt')" :index="menusList.find(data => data.iDenTi === 'beauty-1-qt').menus_name">
        <i :style="desktopStatus == false ? '' : 'color: #4372F8;'" class="iconfont">&#xe60d;</i>
        <span slot="title">{{ menusList.find(data => data.iDenTi === 'beauty-1-qt').menus_name }}</span>
      </el-menu-item>

      <el-menu-item v-if="menusList.find(data => data.iDenTi === 'beauty-1-dd')" :index="menusList.find(data => data.iDenTi === 'beauty-1-dd').menus_name">
        <i :style="desktopStatus == false ? '' : 'color: #FFB940;'" class="iconfont">&#xe601;</i>
        <span slot="title">{{ menusList.find(data => data.iDenTi === 'beauty-1-dd').menus_name }}</span>
      </el-menu-item>

      <el-menu-item v-if="menusList.find(data => data.iDenTi === 'beauty-1-yy')" :index="menusList.find(data => data.iDenTi === 'beauty-1-yy').menus_name">
        <i :style="desktopStatus == false ? '' : 'color: #68D75E;'" class="iconfont">&#xe627;</i>
        <span slot="title">{{ menusList.find(data => data.iDenTi === 'beauty-1-yy').menus_name }}</span>
      </el-menu-item>

      <el-menu-item v-if="menusList.find(data => data.iDenTi === 'beauty-1-lp')" :index="menusList.find(data => data.iDenTi === 'beauty-1-lp').menus_name">
        <i :style="desktopStatus == false ? 'color: white;' : 'color: #B65AF7;font-size: 22px;position: relative;top: 0;'" class="iconfont">&#xe6a7;</i>
        <span slot="title">{{ menusList.find(data => data.iDenTi === 'beauty-1-lp').menus_name }}</span>
      </el-menu-item>

      <el-menu-item v-if="menusList.find(data => data.iDenTi === 'beauty-1-ft')" :index="menusList.find(data => data.iDenTi === 'beauty-1-ft').menus_name">
        <i :style="desktopStatus == false ? 'color: white;' : 'color: #B65AF7;font-size: 22px;position: relative;top: 0;'" class="iconfont">&#xe62d;</i>
        <span slot="title">{{ menusList.find(data => data.iDenTi === 'beauty-1-ft').menus_name }}</span>
      </el-menu-item>

      <el-menu-item v-if="menusList.find(data => data.iDenTi === 'beauty-1-gk')" :index="menusList.find(data => data.iDenTi === 'beauty-1-gk').menus_name">
        <i :style="desktopStatus == false ? '' : 'color: #E5595E;'" class="iconfont">&#xe749;</i>
        <span slot="title">{{ menusList.find(data => data.iDenTi === 'beauty-1-gk').menus_name }}</span>
      </el-menu-item>

      <el-submenu v-if="menusList.find(data => data.iDenTi === 'beauty-1-cw')" :index="menusList.find(data => data.iDenTi === 'beauty-1-cw').menus_name" :class="desktopStatus == false ? 'deskOne' : ''">
        <template slot="title">
          <i :style="desktopStatus == false ? 'color: white;' : 'color: #5AB9F7;'" class="iconfont">&#xe602;</i>
          <span slot="title">{{ menusList.find(data => data.iDenTi === 'beauty-1-cw').menus_name }}</span>
        </template>
        <el-menu-item-group>
          <el-menu-item v-if="menusList.find(data => data.iDenTi === 'beauty-2-yytj')" index="4-1">{{ menusList.find(data => data.iDenTi === 'beauty-2-yytj').menus_name }}</el-menu-item>
          <el-menu-item v-if="menusList.find(data => data.iDenTi === 'beauty-2-yjtc')" index="4-2">{{ menusList.find(data => data.iDenTi === 'beauty-2-yjtc').menus_name }}</el-menu-item>
          <el-menu-item v-if="menusList.find(data => data.iDenTi === 'beauty-2-yytj2')" index="4-3">{{ menusList.find(data => data.iDenTi === 'beauty-2-yytj2').menus_name }}</el-menu-item>
          <!-- <el-menu-item v-if="menusList.find(data => data.iDenTi === 'beauty-2-tcfx')" index="4-5">{{ menusList.find(data => data.iDenTi === 'beauty-2-tcfx').menus_name }}</el-menu-item> -->
          <el-menu-item v-if="menusList.find(data => data.iDenTi === 'beauty-2-gkfx')" index="4-4">{{ menusList.find(data => data.iDenTi === 'beauty-2-gkfx').menus_name }}</el-menu-item>
          <el-menu-item v-if="menusList.find(data => data.iDenTi === 'beauty-2-xsfx')" index="4-6">{{ menusList.find(data => data.iDenTi === 'beauty-2-xsfx').menus_name }}</el-menu-item>
        </el-menu-item-group>
      </el-submenu>

      <!-- <el-menu-item v-if="menusList.find(data => data.iDenTi === 'beauty-1-cq')" :index="menusList.find(data => data.iDenTi === 'beauty-1-cq').menus_name">
        <i :style="desktopStatus == false ? 'color: white;' : 'color: #F7955A;'" class="iconfont">&#xe672;</i>
        <span slot="title">{{ menusList.find(data => data.iDenTi === 'beauty-1-cq').menus_name }}</span>
      </el-menu-item> -->

      <el-menu-item v-if="menusList.find(data => data.iDenTi === 'beauty-1-jxc' && desktopStatus == false)" :class="isCollapse ? 'menuFixedTwoHide' : 'menuFixedTwo'" :index="menusList.find(data => data.iDenTi === 'beauty-1-jxc').menus_name">
        <i class="iconfont">&#xe604;</i>
        <span slot="title">{{ menusList.find(data => data.iDenTi === 'beauty-1-jxc').menus_name }}</span>
      </el-menu-item>

      <el-menu-item v-if="menusList.find(data => data.iDenTi === 'beauty-1-sz' && desktopStatus == false)" :class="isCollapse ? 'menuFixedHide' : 'menuFixed'" :index="menusList.find(data => data.iDenTi === 'beauty-1-sz').menus_name">
        <i class="iconfont">&#xe7b9;</i>
        <span slot="title">{{ menusList.find(data => data.iDenTi === 'beauty-1-sz').menus_name }}</span>
      </el-menu-item>
    </el-menu>
    <!--
            名称： 前台     图标： &#xe60d;   地址： /stage/index
            名称： 订单  图标： &#xe601;   地址： /service/service
            名称： 预约  图标： &#xe627;   地址： /stage/reservationList/allDay
            名称： 顾客  图标： &#xe749;   地址： /stage/customer
            名称： 财务  图标： &#xe602;   地址： /finance/income
            名称： 出勤  图标： &#xe672;   地址： /stage/attendance
            名称： 进销存    图标： &#xe604;
            名称： 设置     图标： &#xe7b9;
        -->
  </div>
</template>
<script>
export default {
  name: 'YzMenu',
  props: {
    menusList: {
      type: Array,
      default: Array
    },
    menuIndex: {
      type: String,
      default: '前台'
    },
    shopImg: {
      type: String,
      default: String
    },
    desktopStatus: {
      type: Boolean
    },
    isCollapse: {
      type: Boolean
    }
  },
  data() {
    return {
      menu: []
    };
  },
  methods: {
    handleOpen(key) {
      if (key === '前台') {
        this.$router.push({
          name: 'stage-index'
        });
      }
      if (key === '订单') {
        if (this.Lib.checkPower('beauty-1-dd') == false) return;
        this.$router.push({
          name: 'service-all'
        });
      }
      if (key === '预约') {
        this.$router.push({
          name: 'stage-reservationList'
        });
      }
      if (key === '顾客') {
        this.$router.push({
          name: 'customer-index'
        });
      }
      // if (key === "财务") {
      //     this.$router.push({
      //         name: "finance-income"
      //     });
      // }
      if (key === '出勤') {
        this.$router.push({
          name: 'stage-attendance'
        });
      }
      if (key === '房态') {
        this.$router.push({
          name: 'room-management'
        });
      }
      if (key === '轮牌') {
        this.$router.push({
          name: 'stage-roundCard'
        });
      }
      if (key === '进销存') {
        for (let i = 0; this.menusList.length > i; i++) {
          if (this.menusList[i].menus_name === key) {
            window.open(this.menusList[i].url);
          }
        }
      }
      if (key === '设置') {
        // console.log(this.menusList)
        for (let j = 0; this.menusList.length > j; j++) {
          // 5.7之前
          // if (this.menusList[j].menus_name === key) {
          //     window.open(window.sessionStorage.setUrl);
          // }
          // 5.7
          if (this.menusList[j].iDenTi === 'beauty-1-sz') {
            window.open(window.sessionStorage.setUrl);
          }
        }
      }
      if (key === '4-1') {
        this.$router.push({
          name: 'finance-income'
        });
      }
      if (key === '4-2') {
        this.$router.push({
          name: 'achivement-index'
        });
      }
      if (key === '4-3') {
        this.$router.push({
          name: 'booking-index'
        });
      }
      if (key === '4-4') {
        this.$router.push({
          name: 'analyse-index'
        });
      }
      if (key === '4-5') {
        this.$router.push({
          name: 'package-overview'
        });
      }
      if (key === '4-6') {
        this.$router.push({
          name: 'project-analysis'
        });
      }
    }
  }
};
</script>

<style>
.el-menu {
    border-right: 0 !important;
}
.el-submenu .el-menu-item {
    min-width: initial !important;
}

.el-menu-item-group > ul {
    color: black !important;
}
.el-menu-item-group__title {
    display: none;
}
.indexC .el-menu-vertical-demo {
    overflow-y: auto;
    height: calc(100% - 232px) !important;
}
.indexC .desktopMenuHeight {
    overflow-y: auto;
    height: calc(100% - 50px) !important;
}
.indexC ul::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    opacity: 0;
}
.indexC ul::-webkit-scrollbar-track-piece {
    opacity: 0;
}
.indexC ul::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
    border-radius: 10px;
    background-color: rgba(0, 0, 0, 0.08);
}
.indexC ul::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
    background-color: rgba(255, 255, 255, 0.3);
}

.el-submenu__title:hover {
    background-color: rgba(0, 0, 0, 0.08) !important;
}
.deskOne .el-submenu__title i {
    color: #fff;
    margin-top: -4px;
}
</style>
<style lang="less" scoped>
.indexLogo {
    height: 60px;
    padding: 30px 0;
    width: 125px;
}
.indexLogo img {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    border: 2px solid #fff;
    margin: 0 auto;
    display: block;
}
.indexLogo2 {
    height: 60px;
    padding: 20px 0;
    width: 65px;
}
.indexLogo2 img {
    width: 31px;
    height: 31px;
    border-radius: 50%;
    border: 2px solid #fff;
    margin: 0 auto;
    display: block;
}
.desktopMenu {
    width: 65px;
    height: 39px;
}
.menu {
    width: 141px;
}
.indexC .el-menu-item {
    background-color: rgba(0, 0, 0, 0);
}
.indexC .el-menu-item span{
  position: relative;
  top: 2px;
}
.indexC .el-menu-item i {
    color: #fff;
}
.indexC i {
    margin-right: 8px;
    position: relative;
    top: 2px;
}
.el-menu-item i {
    font-size: 19px;
}
.menuFixed {
    position: fixed;
    bottom: 0;
    width: 125px;
}
.menuFixedHide {
    position: fixed;
    bottom: 0;
    width: 65px;
}
.menuFixedTwo {
    position: fixed;
    bottom: 56px;
    width: 125px;
}
.menuFixedTwoHide {
    position: fixed;
    bottom: 56px;
    width: 65px;
}
</style>
